import { FC } from 'react';
// components
import AddProductIngredient from 'components/main/ProductIngredient/Edit';

const AddProductIngredients: FC = () => <AddProductIngredient />;

export default AddProductIngredients;
